<div class="bazis-gallery-single">
    <div class="bh-overhide">
        @for (image of images(); track $index; let i = $index) {
            @if (currentIndex === i) {
                @let imageEntity = image.id | entity: image.type | async;
                @if (imageEntity) {
                    <figure class="bazis-figure">
                        <img
                            [src]="imageEntity.$snapshot.file"
                            [alt]="imagesAlt() ? imagesAlt()[i] : imageEntity.$snapshot.name"
                        />
                    </figure>
                }
            }
        }
    </div>

    @if (images().length > 1) {
        <bazis-button
            [fill]="fillControl()"
            color="action"
            class="bazis-gallery-single__prev"
            [size]="sizeControl()"
            [disabled]="currentIndex === 0"
            (click)="currentIndex = currentIndex - 1"
        >
            <bazis-icon
                slot="icon-only"
                [icon]="iconPrev()"
            ></bazis-icon>
        </bazis-button>
        <bazis-button
            [fill]="fillControl()"
            color="action"
            class="bazis-gallery-single__next"
            [size]="sizeControl()"
            [disabled]="currentIndex === images().length - 1"
            (click)="currentIndex = currentIndex + 1"
        >
            <bazis-icon
                slot="icon-only"
                [icon]="iconNext()"
            ></bazis-icon>
        </bazis-button>
    }
</div>
